import { orderDetailsConstants } from "../constants";

export function addOrderId(data) {
  return { type: orderDetailsConstants.ADD_ORDER_ID, payload: data };
}
export function resetOrderId(data) {
  return { type: "RESET", payload: data };
}

